import { DeleteIcon, MoveIcon } from '@synergy/theme-next';
import { FormattedMessage } from 'react-intl';
import { ListItemIcon, ListItemText, Menu, MenuItem, MenuProps, useTheme } from '@mui/material';
import { ReactElement } from 'react';

import { useAppSelector } from '../../../../../store/store';
import { wishListsSelector } from '../../../../store/whish-list-selectors';

export interface RowArticleMobileMenuProps extends MenuProps {
    isAvailableForPurchase: boolean;
    onMove?: () => void;
    onDelete: () => void;
}

export const RowArticleMobileMenu = (props: RowArticleMobileMenuProps): ReactElement => {
    const theme = useTheme();
    const moveArticleEnabled = useAppSelector(wishListsSelector).length > 1;

    const { onMove, onDelete, isAvailableForPurchase, ...menuListProps } = props;

    const deleteColor = !isAvailableForPurchase ? theme.palette.error.main : undefined;

    return (
        <Menu {...menuListProps}>
            <MenuItem onClick={onMove} disabled={!moveArticleEnabled}>
                <ListItemIcon>
                    <MoveIcon />
                </ListItemIcon>
                <ListItemText>
                    <FormattedMessage id="app.wishList.move" />
                </ListItemText>
            </MenuItem>
            <MenuItem onClick={onDelete}>
                <ListItemIcon sx={{ color: deleteColor }}>
                    <DeleteIcon />
                </ListItemIcon>
                <ListItemText sx={{ color: deleteColor }}>
                    <FormattedMessage id="app.wishList.delete" />
                </ListItemText>
            </MenuItem>
        </Menu>
    );
};
